import React from "react";

import { SettingRow } from "../SettingRow";
import { RadioGroup } from "../../../../../../common/components/input/RadioGroup";

export const ConsentBannerBackgroundColorRow = () => {
  return (
    <SettingRow
      maxWidthChildren={true}
      title="Semi-Transparent Background Color"
      helpText="Choose between a light or dark background color for your consent pop-up to match the look of your website."
    >
      <RadioGroup
        field="bannerBackgroundColor"
        aria-label="Semi-Transparent Background Color"
        className="align-items-center"
        row
        options={[
          {
            value: "#eeeeee" /* This color should be kept in sync with PrivacyCenter.kt */,
            label: "Light",
          },
          {
            value: "#222222",
            label: "Dark",
          },
        ]}
      />
    </SettingRow>
  );
};
